import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { Benefit } from '@telialt/models/src/EshopModel';

type GoBackDepth = -1 | -2;

const GIFT_DETAILS_MODAL_ID = 'giftListModal';
export const useGiftDetailsModalControls = () => useBrowserModalControls<[Benefit, GoBackDepth]>(GIFT_DETAILS_MODAL_ID);
